export default {
      id: "layout_list-usage",
      viewBox: "0 0 20 14",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#layout_list",
      toString: function () {
        return this.url;
      }
    }